/** The 26-language P1 AI Pass catalog: code, English name, native name, text direction. */
export const LANGUAGES = [
  { code: 'en', name: 'English', native: 'English', dir: 'ltr' },
  { code: 'es', name: 'Spanish', native: 'Español', dir: 'ltr' },
  { code: 'fr', name: 'French', native: 'Français', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese', native: 'Português', dir: 'ltr' },
  { code: 'de', name: 'German', native: 'Deutsch', dir: 'ltr' },
  { code: 'it', name: 'Italian', native: 'Italiano', dir: 'ltr' },
  { code: 'ru', name: 'Russian', native: 'Русский', dir: 'ltr' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe', dir: 'ltr' },
  { code: 'fa', name: 'Persian', native: 'فارسی', dir: 'rtl' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili', dir: 'ltr' },
  { code: 'ja', name: 'Japanese', native: '日本語', dir: 'ltr' },
  { code: 'ko', name: 'Korean', native: '한국어', dir: 'ltr' },
  { code: 'zh-Hans', name: 'Chinese (Simplified)', native: '简体中文', dir: 'ltr' },
  { code: 'zh-Hant', name: 'Chinese (Traditional)', native: '繁體中文', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', native: 'العربية', dir: 'rtl' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी', dir: 'ltr' },
  { code: 'bn', name: 'Bangla', native: 'বাংলা', dir: 'ltr' },
  { code: 'ur', name: 'Urdu', native: 'اردو', dir: 'rtl' },
  { code: 'id', name: 'Indonesian', native: 'Bahasa Indonesia', dir: 'ltr' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu', dir: 'ltr' },
  { code: 'th', name: 'Thai', native: 'ไทย', dir: 'ltr' },
  { code: 'vi', name: 'Vietnamese', native: 'Tiếng Việt', dir: 'ltr' },
  { code: 'fil', name: 'Filipino', native: 'Filipino', dir: 'ltr' },
  { code: 'my', name: 'Burmese', native: 'မြန်မာ', dir: 'ltr' },
  { code: 'km', name: 'Khmer', native: 'ខ្មែរ', dir: 'ltr' },
  { code: 'lo', name: 'Lao', native: 'ລາວ', dir: 'ltr' },
];

export const CODES = LANGUAGES.map((l) => l.code);
export const languageOf = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
